<script setup>
import {ref, onMounted} from 'vue'
import axios from "axios";
//----------------------------------------------------------------------
const news = ref([])
onMounted( ()=>{
  init()
})

const init = async () => {
  let urlNews = process.env.VUE_APP_API + 'news.php'
  await axios
      .get(`${urlNews}`)
      .then(response => (news.value = response.data))
      .catch(error => alert(error));
}
</script>

<template>
  <div class="modal-body">
    <div v-if="news.length > 0">
      <div v-for="(info, index) in news" :key="index">
        <div class="number">{{ index+1 }}</div>
        <div class="v-line"></div>
        <div class="info text-center">
          <h5 class="text-center">{{ info['title']}}</h5>
        </div>
        <p class="p-3">{{ info['text']}}</p>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center">
      <div
          class="spinner-border text-primary m-4" role="status"
      ></div>
    </div>
  </div>
</template>
<style scoped>
.number{
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  width:50px;
  height:50px;
  border:3px solid #d5e5fa;
  border-radius:50%;
  font-size:1.2rem;
  margin: 0 auto;
}
.v-line{
  width:3px;
  height:25px;
  background-color: #d5e5fa;
  margin: 0 auto;
}
.info{
  background-color: #d5e5fa;
  padding: 15px 10px 10px 10px;
  border-radius: 5px;
}
</style>